<!-- 固定个人信息 -->
<template>
  <div class="cen">
    <div class="box">
      <div class="phimg">
        <img v-if="basic.idPhoto" :src="img + basic.idPhoto" class="avatar" />
        <img v-else src="../assets/uphei.png" alt="" />
      </div>
      <div class="hang">
        <div><span>中考报名序号：</span>{{ basic.bmNumber | exe }}</div>
        <!-- <div><span>学生姓名：</span>{{ basic.name | exe }}</div> -->
        <div><span>身份证号：</span>{{ basic.idCard | exe }}</div>
        <div><span>毕业中学：</span>{{ basic.schoolName | exe }}</div>
      </div>
      <div class="hang">
        <div><span>学生姓名：</span>{{ basic.name | exe }}</div>
        <div><span>性别：</span>{{ basic.gender | sex }}</div>
        <!-- <div v-if="basic.grade == '9'"><span>年级：</span>9年级</div>
        <div v-else-if="basic.grade == '8'"><span>年级：</span>8年级</div>
        <div v-else><span>年级：</span>暂无获取</div> -->
        <div><span>班级：</span>{{ basic.classCode | ban }}</div>
      </div>
      <div class="hang">
        <div><span>民族：</span>{{ nation | exe }}</div>
        <div><span>学籍号：</span>{{ basic.xjNumber | exe }}</div>
        <!-- <div><span>政治面貌：</span>{{ basic.political | exe }}</div> -->
        <div><span>外语语种：</span>{{ language | exe }}</div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  getNation,
  getLanguage,
  getUserInfo,
  getschool,
  getsarends,
  getLastRegInfo,
} from "@/api/api";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      img: process.env.VUE_APP_VIEW_IMG_URL,
      basic: {
        //基本信息
        bmid: JSON.parse(sessionStorage.getItem("login")).bmNumber,
        url: "", //显示头像
        img: "", //传给后端头像
        sname: "", //学校名称
        class: "", //班级
        name: "", //学生姓名
        sid: "", //学号
        idno: "", //身份证号
        sex: "", //性别
        birthday: "", //出生日期
        nation: "", //民族
        nationid: "", //民族id 01-汉族 02-蒙古族 03-回族 10-朝鲜族 11-满族 57-其他
        //报考信息
        language: "", //外语语种
        languageid: "", //外语语种id 0-英语 1-俄语 2-日语
        reviewStatus: "", //登记状态
        nianji: "", // 年级
      },
      sname: "",
      nation: "",
      language: "",
      byxxlist: [], //毕业学校集合
      mzlist: [], //民族集合
      wyyzlist: [], //外语语种集合
      appConfig: {}, // 配置对象
    };
  },
  filters: {
    exe(val) {
      // console.log(val);
      return val ? val : "暂未获取";
    },
    ban(val) {
      // console.log(val);
      return val ? val + "班" : "暂未获取";
    },
    sex(val) {
      // console.log(val);
      if (val) {
        return val == "0" ? "男" : "女";
      } else {
        return "暂未获取";
      }
    },
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (JSON.parse(sessionStorage.getItem("nation"))) {
      this.mzlist = JSON.parse(sessionStorage.getItem("nation"));
    } else {
      this.getNation();
    }
    if (JSON.parse(sessionStorage.getItem("language"))) {
      this.wyyzlist = JSON.parse(sessionStorage.getItem("language"));
    } else {
      this.getLanguage();
    }
    if (JSON.parse(sessionStorage.getItem("byschool"))) {
      this.byxxlist = JSON.parse(sessionStorage.getItem("byschool"));
    } else {
      this.getschool();
    }
    this.getNation();
    this.getLanguage();
    this.getschool();
    this.getConfig();
    this.getUserInfo();
  },
  //方法集合
  methods: {
    // 获取当前开启配置
    async getConfig() {
      const data = await getsarends();
      console.log(data);
      this.appConfig = data.data;
    },
    //获取民族
    async getNation() {
      const res = await getNation();
      console.log(res);
      if (res.code == 200) {
        this.mzlist = res.data;
        res.data.forEach((e) => {
          if (e.dictValue == this.basic.nation) {
            this.nation = e.dictLabel;
          }
        });
        sessionStorage.setItem("nation", JSON.stringify(res.data));
      } else {
        this.$message.error(res.msg);
      }
    },
    //获取语种
    async getLanguage() {
      const res = await getLanguage();
      console.log(res);
      if (res.code == 200) {
        this.wyyzlist = res.data;
        res.data.forEach((e) => {
          if (e.dictValue == this.basic.foreignLanguages) {
            this.language = e.dictLabel;
          }
        });
        sessionStorage.setItem("language", JSON.stringify(res.data));
      } else {
        this.$message.error(res.msg);
      }
    },
    //获取学校
    async getschool() {
      const data = await getschool();
      console.log(data);
      if (data.code == 200) {
        this.byxxlist = data.data;
        sessionStorage.setItem("byschool", JSON.stringify(data.data));
        // this.byxxlist.forEach((e) => {
        //   if (e.id == this.basic.schoolId) {
        //     this.sname = e.schoolName;
        //   }
        // });
      } else {
        this.$message.error(data.msg);
      }
    },
    //信息查询
    async getUserInfo() {
      this.$tip(true, "正在加载中。。");
      const data = await getUserInfo({
        id: JSON.parse(sessionStorage.getItem("login")).bmNumber,
      });
      this.$tip(false);
      console.log(data);
      if (data.code == 200) {
        this.basic = data.data;
        // this.byxxlist.forEach((e) => {
        //   if (e.id == this.basic.graduationSchoolId) {
        //     this.sname = e.schoolName;
        //   }
        // });
        //判断获取去年是否报名过
        console.log(this.basic);

        if (
          this.basic.name == null &&
          this.basic.idCard == null &&
          this.basic.xjNumber == null
        ) {
          console.log("报名过");
          this.getLastRegInfo();
        } else {
          sessionStorage.setItem(
            "userid",
            JSON.stringify(data.data.userInfoId)
          );
          this.mzlist.forEach((e) => {
            if (e.dictValue == this.basic.nation) {
              this.nation = e.dictLabel;
            }
          });
          this.wyyzlist.forEach((e) => {
            if (e.dictValue == this.basic.foreignLanguages) {
              this.language = e.dictLabel;
            }
          });
        }
      } else {
        // this.$message.error(data.msg);
        this.$message({
          message: data.msg,
          type: "error",
          offset: "100",
        });
      }
    },
    //获取上一年信息查询
    async getLastRegInfo() {
      this.$tip(true, "正在加载中。。");
      const data = await getLastRegInfo({
        id: JSON.parse(sessionStorage.getItem("login")).bmNumber,
      });
      this.$tip(false);
      console.log(data);
      if (data.code == 200) {
        this.basic = data.data;
        // this.byxxlist.forEach((e) => {
        //   if (e.id == this.basic.graduationSchoolId) {
        //     this.sname = e.schoolName;
        //   }
        // });
        // sessionStorage.setItem("userid", JSON.stringify(data.data.userInfoId));
        this.mzlist.forEach((e) => {
          if (e.dictValue == this.basic.nation) {
            this.nation = e.dictLabel;
          }
        });
        this.wyyzlist.forEach((e) => {
          if (e.dictValue == this.basic.foreignLanguages) {
            this.language = e.dictLabel;
          }
        });
      } else {
        // this.$message.error(data.msg);
        this.$message({
          message: data.msg,
          type: "error",
          offset: "100",
        });
      }
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
/*@import url(); 引入公共css类*/
.cen {
  width: 100%;
  //   height: 4rem;
  background-color: #f1f1f1;
  display: flex;
  justify-content: center;
  padding: 1rem 0rem;
  .box {
    width: 88%;
    font-size: 1.4rem;
    display: flex;
    align-items: center;
    background-color: #fff;
    padding: 1rem 0rem;
  }
}
.hang :last-child {
  margin-bottom: 0rem !important;
}
.hang {
  display: flex;
  flex-direction: column;
  font-size: 0.8rem;
  margin-left: 6rem;
  div {
    margin-bottom: 1rem;
    display: flex;
    // align-items: center;
    align-items: flex-end;
  }
  span {
    width: 6rem;
    display: flex;
    justify-content: flex-end;
  }
}
.phimg {
  cursor: pointer;
  width: 6rem;
  height: 8rem;
  background-color: #f4f4f4;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 2rem;
  img {
    width: 3rem;
    // height: 8rem;
  }
  .avatar {
    width: 6rem;
    height: 8rem;
  }
}
</style>
